/* Bower — quiet-line rotator
 *
 * Crossfades through the eight italic taglines. Cadence 5s. Pauses on
 * hover, on `document.hidden`, and (via CSS) on prefers-reduced-motion.
 */
(function () {
  const root = document.querySelector('.bower-quiet__line');
  if (!root) return;

  const items = Array.from(root.querySelectorAll('.bower-quiet__q'));
  if (items.length < 2) return;

  let i = 0;
  let timer = null;
  let hovering = false;
  const intervalMs = 5000;
  const leaveLingerMs = 1500;

  function step() {
    const cur = items[i];
    i = (i + 1) % items.length;
    const next = items[i];
    cur.classList.remove('is-active');
    cur.classList.add('is-leaving');
    next.classList.remove('is-leaving');
    next.classList.add('is-active');
    setTimeout(() => cur.classList.remove('is-leaving'), leaveLingerMs);
  }

  function start() {
    stop();
    if (hovering || document.hidden) return;
    timer = setInterval(step, intervalMs);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  root.addEventListener('mouseenter', () => { hovering = true; stop(); });
  root.addEventListener('mouseleave', () => { hovering = false; start(); });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  start();
})();
